import styled from '@emotion/styled';
import { icons } from '@assets/icons';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const StyledReportArea = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 40px;
  & > strong {
    position: relative;
    display: block;
    width: 80px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
    color: #333;
  }
`;

export const StyledReportFlex = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 32px;
  color: #555;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }
`;
